/**
 * @desc first run common across app
 */

!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('common/firstRun',['libs/ct_store'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.Store)
}('firstRun', function(store){
	var firstRun = {
		showFirstRunTipsy : function(el){
			var that = this , $currentTab = $('#ResultContainer_' + CT.settings.currentTab) ,toStoreEle = [] , 
					   showedEle = store("UI").get('firstRunEle'),ele,currEle,markup,offset=0,displayFirstRun = false,diff;
			//Check for cookie to display.To be displayed only once per day
			
			if(CT.utils.cookies.read("firstRunNeverShow")){
				//Never show the first run resetting again to 365 days
				CT.utils.cookies.create('firstRunNeverShow',moment() , 365);
				displayFirstRun = false 
			}else if(CT.utils.cookies.read("firstRunEleShown") === null){
				displayFirstRun = true
			}else{
				diff =  moment().diff(moment(parseInt(CT.utils.cookies.read("firstRunEleShown"))),'minutes')
				diff >= 2?displayFirstRun = true:displayFirstRun = false;
			}
			
			if(displayFirstRun == true){
				//Get the remaining ele array to be shown.
				
				if(_.size(showedEle) != 0){
					toStoreEle = showedEle
					for(var i = 0;i<toStoreEle.length;i++){
						if(CT.settings[CT.app].firstRunEle.indexOf(toStoreEle[i]) != -1){
							delete CT.settings[CT.app].firstRunEle[CT.settings[CT.app].firstRunEle.indexOf(toStoreEle[i])]
						}
					}
				}
				
				
				var tmpArray = _.compact(CT.settings[CT.app].firstRunEle);
				ele = tmpArray.pop();
				
				
				if(ele && $("."+ele).length > 0 && $("."+ele).is(":visible")){
					currEle = CT.settings[CT.app].firstRunObj[tmpArray.length];
					if(ele in currEle){
						if(CT.cache[CT.settings.currentTab].searchParams.all.trip_type == "OneWay" || CT.cache[CT.settings.currentTab].searchParams.all.isIntl == false) {
							if(tmpArray.length > 1){
								currEle[ele].showNext = true;
							}
						}else{
							if(tmpArray.length > 0){
								currEle[ele].showNext = true;
							}
						}
						
						markup = CT.to_html('FirstRunTemplate', currEle[ele]);
						if(ele === "vIndicator"){
							var orgTitle = $($("."+ele)[0]).attr("title");
							$($("."+ele)[0]).attr("tooltipTitle",orgTitle).removeAttr("rel").removeAttr("title");
							offset = 20;
						}
						if(ele === "miniCalendar"){
							offset = 15;
						}
						$currentTab.find("."+ele).tipsy({
							gravity : currEle[ele].direction,
							trigger: 'manual',
							delayIn: 1500,
					        fade: true,
					        offset:offset,
							addCloseButton: true,
							opacity:0.95,
							html : true,
							className : 'popOver firstRun contentPopOver',
							fallback: markup
						}).tipsy('show');
						toStoreEle.push(ele)
						store("UI").set("firstRunEle", toStoreEle);
						//For the main screen hide the arrow and close button
						if(ele === "primaryBar"){
							 $(".tipsyArrow").hide();
							 $(".firstRun .close").hide();
							 $(".firstRun").addClass("welcomeStep");
							 $(".firstRun").css({"position":"absolute",
								 "top": ($(window).height() / 2) - ($(".firstRun").outerHeight() / 2),
								 "left": ($(window).width() / 2) - ($(".firstRun").outerWidth() / 2)
							 		})
						
						}
						//Click for next button
						$(".nextEle").click(function(e){
							e.preventDefault()
							//Condition for visual indicator flights.Resetting the original tooltip title
							if(e.target.id === "vi"){
								var tooltipTitle = $('#ResultContainer_' + CT.settings.currentTab).find(".vIndicator").attr("tooltipTitle")
								$('#ResultContainer_' + CT.settings.currentTab).find(".vIndicator").attr({"rel":"tTooltip","title":tooltipTitle}).tipsy("destroy");
							}
							//Erase the cookie set if present
							if(CT.utils.cookies.read("firstRunEleShown")){
								CT.utils.cookies.erase("firstRunEleShown");
							}
							$(".firstRun").remove();
							that.showFirstRunTipsy(el);
						})
						//Dismiss link clicked
						$(".closeFirstRun").click(function(e){
							e.preventDefault()
							//First screen where user clicks never show(I'll figure out)
							if(e.target.id && e.target.id != "" && e.target.id === "neverShow"){
								//Never show the first run
								CT.utils.cookies.create('firstRunNeverShow',moment() , 365);
							}else{
								//dont show the first run for atleast a day
								CT.utils.cookies.create('firstRunEleShown',moment() , 1);
							}
							//Condition for visual indicator flights.Resetting the original tooltip title
							if(e.target.id === "vi"){
								var tooltipTitle = $('#ResultContainer_' + CT.settings.currentTab).find(".vIndicator").attr("tooltipTitle")
								//var tooltipTitle = $(".vIndicator")[0].attr("tooltipTitle")
								$('#ResultContainer_' + CT.settings.currentTab).find(".vIndicator").attr({"rel":"tTooltip","title":tooltipTitle}).tipsy("destroy");
							}
							$(".firstRun").remove();
						})
					}
				}else if(ele){
					CT.settings[CT.app].firstRunEle.pop();
					that.showFirstRunTipsy(el);
	
				}
			}
		}
	};
	return firstRun
}, this)
;
